import { useQuery } from '@tanstack/react-query';
import { getJourneySchedule } from 'Global/JourneyElements/Api/JourneyService';
import { Journey } from '../Types/Journey';

/**
 * A sailing's departure and arrival times for one leg. A query, so the several places a booking card
 * shows the same leg's time (its title and its date chip, on the cart and again on the success page)
 * share one request.
 */
export const useJourneySchedule = (journey: Journey) => {
	const tripId = journey?.tripId;
	const startStopId = journey?.startStopId;
	const endStopId = journey?.endStopId;

	return useQuery({
		queryKey: ['journey-schedule', tripId, startStopId, endStopId],
		queryFn: () => getJourneySchedule({ tripId, startStopId, endStopId }),
		enabled: !!tripId && !!startStopId && !!endStopId,
		// A sailing's times rarely move, but staff can retime a trip and come straight back to a booking
		// on it — kept to a minute so the old time does not linger long after that.
		staleTime: 60 * 1000,
	});
};
